import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { DatatableProps } from "../../common/data/interface/index";

const Datatable: React.FC<DatatableProps> = ({
  columns,
  dataSource,
  Search,
  pagination,
  isLoading,
  onChange,
}) => {
  const [searchText, setSearchText] = useState<string>("");
  const [showSearch, setShowSearch] = useState<any>(true);
  const [filteredDataSource, setFilteredDataSource] = useState(dataSource);

  const handleSearch = (value: string) => {
    setSearchText(value);
    const filteredData = dataSource.filter((record) =>
      Object.values(record).some((field) =>
        String(field).toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredDataSource(filteredData);
  };

  useEffect(() => {
    setFilteredDataSource(dataSource);
  }, [dataSource]);

  useEffect(() => {
    setShowSearch(Search);
  }, [Search]);

  const handleTableChange = (paginationInfo: any) => {
    if (onChange) {
      onChange({
        current: paginationInfo.current,
        pageSize: paginationInfo.pageSize,
      });
    }
  };

  return (
    <div className="custom-table antd-custom-table">
      {showSearch && (
        <div className="table-search">
          <div className="input-icon mb-3">
            <span className="input-icon-addon">
              <i className="isax isax-search-normal-14" />
            </span>
            <input
              type="search"
              className="form-control form-control-md mb-3 w-auto float-end"
              value={searchText}
              placeholder="Search"
              onChange={(e) => handleSearch(e.target.value)}
            />
          </div>
        </div>
      )}
      <Table
        className="table datanew dataTable no-footer"
        columns={columns}
        rowHoverable={false}
        loading={isLoading}
        dataSource={searchText ? filteredDataSource : dataSource}
        pagination={{
          current: pagination?.current,
          pageSize: pagination?.pageSize,
          total: pagination?.total,
          locale: { items_per_page: "" },
          nextIcon: (
            <span>
              <i className="fas fa-angle-right" />
            </span>
          ),
          prevIcon: (
            <span>
              <i className="fas fa-angle-left" />
            </span>
          ),
          showTotal: (total, range) =>
            `Page ${pagination?.current} of ${pagination?.last_page}`,
        }}
        onChange={handleTableChange}
      />
    </div>
  );
};

export default Datatable;
